module.exports = __webpack_public_path__ + "img/46.41501b46.jpg";